import axios from 'axios';
import AuthService from './AuthService';

export default class ApiService {
  /**
   * リクエストを送信するベースメソッド
   * 認証エラーが発生した場合はIDトークンを再取得してリクエスト再送信。
   * IDトークン再取得失敗時にはアラートを出しログイン画面へ遷移。
   * @param {string} url リクエスト先URL
   * @param {Object} params 送信パラメータ
   */
  sendRequest(url, params, callBackFunction) {
    // CORS、認証用ヘッダ設定
    const headers = {
      'content-type': 'application/json',
      Authorization: localStorage.getItem('idToken'),
    };

    // リクエスト送付
    axios
      .post(url, params, { headers: headers })
      .then((response) => {
        if (response.status == 200) {
          // 取得成功時には取得結果をPromiseにして返却
          callBackFunction(response);
        } else {
          callBackFunction({});
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status == 401) {
          // 認証エラー時には認証トークンを再取得
          const authService = new AuthService();
          authService.refreshToken( (response) => {
            if (response.status == 200) {
              // 再取得したトークンでAPI再コール
              headers.Authorization = localStorage.getItem('idToken');
              axios.post(url, params, { headers: headers }).then((response) => {
                callBackFunction(response);
              });
            } else {
             callBackFunction(response)
            }
          });
        } else {
          // 認証エラー以外の場合は呼び出しもとでハンドリングするので結果をPromiseにして返却
          callBackFunction(error);
        }
      });
  }

  /**
   * リクエストを送信するベースメソッド
   * 認証エラーが発生した場合はIDトークンを再取得してリクエスト再送信。
   * IDトークン再取得失敗時にはアラートを出しログイン画面へ遷移。
   * @param {string} url リクエスト先URL
   * @param {Object} params 送信パラメータ
   */
  sendGetRequest(url, params, callBackFunction) {
    // CORS、認証用ヘッダ設定
    const headers = {
      'content-type': 'application/json',
      Authorization: localStorage.getItem('idToken'),
    };
  
    // リクエスト送付
    axios
      .get(url, { params: params, headers: headers })
      .then((response) => {
        if (response.status == 200) {
          // 取得成功時には取得結果をPromiseにして返却
          callBackFunction(response);
        } else {
          callBackFunction({});
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status == 401) {
          // 認証エラー時には認証トークンを再取得
          const authService = new AuthService();
          authService.refreshToken((response) => {
            if (response.status == 200) {
              // 再取得したトークンでAPI再コール
              headers.Authorization = localStorage.getItem('idToken');
              axios.get(url, { params: params, headers: headers }).then((response) => {
                callBackFunction(response);
              });
            } else {
              callBackFunction(response)
            }
          });
        } else {
          // 認証エラー以外の場合は呼び出しもとでハンドリングするので結果をPromiseにして返却
          callBackFunction(error);
        }
      });
  }

  checkQRCode(workerId, callBackFunction) {
    // APIエンドポイントの設定
    const API_GET_PLACE_LIST = process.env.API_ENDPOINT + '/get_worker_data';

    // リクエストパラメータの設定
    const params = {
      edge_device_id: localStorage.getItem('deviceId'),
      data_source: 'working_record',
      worker_id: workerId
    }

    this.sendRequest(API_GET_PLACE_LIST, params, callBackFunction)
  }

  getPlaceList(callBackFunction) {
    // APIエンドポイントの設定
    const API_GET_PLACE_LIST = process.env.API_ENDPOINT + '/place/list';

    // リクエストパラメータの設定
    const params = {
      edge_device_id: localStorage.getItem('deviceId'),
      data_source: 'working_record'
    }


    this.sendGetRequest(API_GET_PLACE_LIST, params, callBackFunction)
  }

  getTaskList(callBackFunction) {
    // APIエンドポイントの設定
    const API_GET_PLACE_LIST = process.env.API_ENDPOINT + '/task/list';

    // リクエストパラメータの設定
    const params = {
      edge_device_id: localStorage.getItem('deviceId'),
      data_source: 'working_record'
    }

    this.sendGetRequest(API_GET_PLACE_LIST, params, callBackFunction)
  }

  saveWorkingRecord(workRecordData, callBackFunction) {
    // APIエンドポイントの設定
    const API_GET_PLACE_LIST = process.env.API_ENDPOINT + '/workingrecord';

    // リクエストパラメータの設定
    const params = {
      edge_device_id: localStorage.getItem('deviceId'),
      data_source: 'working_record',
      send_data: workRecordData
    }

    this.sendRequest(API_GET_PLACE_LIST, params, callBackFunction)
  }
}




// WEBPACK FOOTER //
// ./src/services/ApiService.js